export const HOME_API_CONSTANTS = {
  RESEARCH_NEWS_UPDATES: "research/getResearchNewsUpdates/all",
  WEBINARS: "research/getResearchNewsUpdates/all",
  ENDMILE_EVENT_TRACK: "eventemileProcess",
  NEW_ENDMILE_EVENT_TRACK: "newEventEndmileProcess",
  GET_MACHINE_ID: "machineId",
  USER_IP_ADDRESS: "auth/getclientipbydomain",
  SPEAKER_EXPERTISE_LIST: "events/speaker/expertise",
  COLLABORATE_AS_SPEAKER: "events/speaker/apply",
  SUBSCRIPTION_NOTIFICATION: "events/subscriptionnotification",
  IP_BASED_LOGIN: "auth/ipUserLogin",
};
